import { useCallback } from "react"
import * as E from "fp-ts/Either"
import { pipe } from "fp-ts/function"
import useContinueWriteStore from "../store/useContinueWriteStore"
import fetchClientSentencesRecent from "../fatch/fetchClientSentencesRecent"

const useContinueWriteList = () => {
  const { items, setData, clear } = useContinueWriteStore()
  const REQUEST_SIZE = 3

  const fetch = useCallback(async () => {
    const result = await fetchClientSentencesRecent({ limit: REQUEST_SIZE })
    pipe(
      result,
      E.match(
        () => {},
        (v) => {
          setData(v)
        },
      ),
    )
  }, [setData])

  return {
    items,
    fetch,
    clear,
  }
}

export default useContinueWriteList
